import { ICustomTheme } from 'interfaces';
import styled from '@emotion/styled';
import { css, SerializedStyles } from '@emotion/core';
import {
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  IconButton as MuiIconButton,
  Typography,
} from '@material-ui/core';

import {
  skipDisabledPropOption,
  getMainColor,
} from '../pages/DetailsPage/common/styles';

type Theme = {
  theme?: ICustomTheme;
};

export const IconButton = styled(
  MuiIconButton,
  skipDisabledPropOption,
)<{
  theme: ICustomTheme;
  isDisabled?: boolean;
}>(({ theme, isDisabled }) => ({
  height: 49,
  width: 49,
  [theme.breakpoints.down('sm')]: {
    height: 40,
    width: 40,
  },
  backgroundColor: theme.colors.white,
  '.Mui-expanded &': {
    color: getMainColor(theme, isDisabled),
    backgroundColor: theme.colors.grey.light5,
  },
}));

export const AccordionSummary = styled(MuiAccordionSummary)<Theme>(
  ({ theme }) => ({
    backgroundColor: theme.colors.grey.light5,
    '&.Mui-expanded': {
      backgroundColor: theme.colors.white,
    },
    width: '100%',
    minHeight: 112,
    [theme.breakpoints.down('sm')]: {
      minHeight: 60,
    },
  }),
);

export const AccordionDetails = styled(MuiAccordionDetails)<Theme>(
  ({ theme }) => ({
    minHeight: 310,
    [theme.breakpoints.down('sm')]: {
      minHeight: 180,
    },
  }),
);

export const cssAccordion = (theme: ICustomTheme): SerializedStyles =>
  css({
    boxShadow: theme.shadows[3],
    overflow: 'hidden',
    margin: `${theme.spacing(4)}px auto !important`,
    [theme.breakpoints.down('sm')]: {
      margin: `${theme.spacing(2)}px auto !important`,
    },
  });

export const cssSkeleton = (theme: ICustomTheme): SerializedStyles =>
  css({
    height: 180,
    boxShadow: theme.shadows[3],
    width: '90%',
    margin: `${theme.spacing(4)}px auto !important`,
    [theme.breakpoints.down('sm')]: {
      margin: `${theme.spacing(2)}px auto !important`,
      height: 100,
    },
  });

export const Title = styled(
  Typography,
  skipDisabledPropOption,
)<{
  theme: ICustomTheme;
  isDisabled?: boolean;
}>(({ theme, isDisabled }) => ({
  fontSize: 33,
  marginLeft: theme.spacing(22),
  [theme.breakpoints.down('sm')]: {
    fontSize: 14,
    marginLeft: 0,
    textAlign: 'center',
    width: '100%',
  },
  '.Mui-expanded &': {
    color: getMainColor(theme, isDisabled),
  },
}));

export const DescriptionSection = styled.div<Theme>(({ theme }) => ({
  margin: `${theme.spacing(4)}px auto`,
  [theme.breakpoints.down('sm')]: {
    margin: `${theme.spacing(2)}px auto`,
  },
}));
